import React from 'react';

const AdcDivider = ({ 
  size = 'small', 
  spacing = '12', 
  color = 'default',
  className = ''
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'h-px';
      case 'medium':
        return 'h-0.5';
      case 'large':
        return 'h-1';
      default:
        return 'h-px';
    }
  };

  const getColorClass = () => {
    switch (color) {
      case 'default':
        return 'bg-[#ccc]';
      case 'light':
        return 'bg-[#e0e0e0]';
      case 'dark':
        return 'bg-[#999]';
      default:
        return 'bg-[#ccc]';
    }
  };

  const getSpacingClass = () => {
    const spacingValue = parseInt(spacing);
    return `mb-${Math.floor(spacingValue / 4)}`;
  };

  return (
    <div 
      className={`divider adc-divider ${getSizeClass()} ${getColorClass()} ${getSpacingClass()} ${className}`}
      role="separator"
    />
  );
};

export default AdcDivider;